/* 🤖 this file was generated by script */
export const wiconMoon02 = {
  name: 'moon_02',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21.95 12.96a8 8 0 11-10.9-10.92 10 10 0 1010.9 10.92z"/></svg>`,
};
